import gql from 'graphql-tag';

import { DEAL_ACTIVITY_FRAGMENT } from './fragments/dealEventActivity.fragment';

export const COMPLETE_EVENT_ACTIVITIES = gql`
  mutation CompleteEventActivities($input: CompleteEventActivitiesInput!) {
    dealActivity {
      result: completeEventActivities(input: $input) {
        error
        success
        list {
          __typename
          ...DealEventActivityFields
        }
      }
    }
  }
  ${DEAL_ACTIVITY_FRAGMENT}
`;
